import { render, staticRenderFns } from "./QNA.Detail.vue?vue&type=template&id=6431012a&"
import script from "./QNA.Detail.vue?vue&type=script&lang=js&"
export * from "./QNA.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports